import { Box, Switch, Tooltip } from "@mui/material"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setSnackbar } from "../../../redux/messageSlice"
import { toggleAssignmentAvailabilityApi } from "../../../services/api"
import { showSnackBar } from "../../../utils/commonServices"
import useDashboardActions from "../../dashboard/useDashboardActions"

const EditorAvailabilityToggle = ({ user }) => {
    const dispatch = useDispatch()
    const commonReducer = useSelector((state) => state.root.commonReducer)

    const isEditor = user?.role_name === 'Editor'
    const currentUserIsAdmin = commonReducer?.role_name === 'Admin'

    const [available, setAvailable] = useState(!!user?.available_for_assignment)
    const [loading, setLoading] = useState(false)
    const { getOrganisationMembersList } = useDashboardActions()

    useEffect(() => {
        setAvailable(!!user?.available_for_assignment)
    }, [user?.available_for_assignment])

    if (!isEditor || !currentUserIsAdmin) return null

    const handleToggle = () => {
        if (loading) return
        setLoading(true)
        toggleAssignmentAvailabilityApi({ internal_user_id: user?.id })
            .then((response) => {
                setLoading(false)
                if (response?.data?.http_code === 200 || response?.data?.status === 200) {
                    dispatch(setSnackbar({
                        type: 'success',
                        flag: true,
                        message: response?.data?.message
                    }))
                    getOrganisationMembersList()
                }
            })
            .catch((error) => {
                setLoading(false)
                if (error) {
                    const errorObject = error?.response?.data
                    showSnackBar(dispatch, errorObject)
                }
            })
    }

    return (
        <Tooltip title={available ? 'Available for auto-assign' : 'Unavailable for auto-assign'} placement="top">
            <span>
                <Switch
                    checked={available}
                    onChange={handleToggle}
                    disabled={loading}
                    size="small"
                    sx={{
                        '& .MuiSwitch-switchBase.Mui-checked': { color: '#4CAF50' },
                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#4CAF50' },
                    }}
                />
            </span>
        </Tooltip>
    )
}

export default EditorAvailabilityToggle
